export class NodeHelper {

    static BUSINESS_UNIT_ID_FIELD_ID = 'Presupuesto_ID';
    static CHANNEL_FIELD_ID = 'Canal';
    static ACCOUNT_ID_FIELD_ID = 'Cuenta_ID';

    static FILTER_TYPE_EXCLUDE = 'EXCLUDE';
    static FILTER_TYPE_INCLUDE = 'INCLUDE';

    static FILTER_OPERATOR_EQUALS = 'EQUALS';

    /**
     * Se fija si en los filtros de dimensiones se está filtrando unicamente por businessUnitId, channel y accountId.
     * Devuelve un objeto con este formato: { businessUnitId: Optional<number>, channel: Optional<string>, accountId: Optional<number> }
     * @param {Array} dimensionsFiltersGroups - Los grupos de filtros de dimensiones
     * @returns {Object} - Un objeto con este formato: { businessUnitId: Optional<number>, channel: Optional<string>, accountId: Optional<number> }
     */
    static convertDimensionsFiltersToSelectedBusinessUnitIdOrChannelAndAccountId(dimensionsFiltersGroups) {
        let result = { businessUnitId: null, channel: null, accountId: null };
        if (!dimensionsFiltersGroups || !Array.isArray(dimensionsFiltersGroups) || dimensionsFiltersGroups.flat().length === 0) {
            return result;
        }
        dimensionsFiltersGroups.forEach(filterGroup => {
            if (filterGroup.length > 1) {
                return;
            }

            const filter = filterGroup[0];
            if (!filter || !filter.values || !filter.type || !filter.operator || !filter.fieldName || filter.values.length !== 1) {
                return;
            }

            if (filter.type === this.FILTER_TYPE_INCLUDE && filter.operator === this.FILTER_OPERATOR_EQUALS) {
                if (filter.fieldName === this.BUSINESS_UNIT_ID_FIELD_ID) {
                    result.businessUnitId = filter.values[0];
                } else if (filter.fieldName === this.CHANNEL_FIELD_ID) {
                    result.channel = filter.values[0];
                } else if (filter.fieldName === this.ACCOUNT_ID_FIELD_ID) {
                    result.accountId = filter.values[0];
                }
            }
        });
        return result;
    }
}